module.exports = __webpack_public_path__ + "static/img/androidimg.79db9ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopping/androidimg.png
// module id = LznM
// module chunks = 1